import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  cardId: string;
}

interface Result {}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/card/approve/',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useApproveCardVersionLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useApproveCardVersionLazy;
